import React from "react";
import "./CTA.scss";

const CTA = () => {
  return (
    <section className="cta" id="contacto">
      <div className="cta__container">
        <div className="cta__box">
          <span className="cta__eyebrow">Cotiza tu proyecto</span>

          <h2 className="cta__title">
            ¿Buscas una solución en vidrio y aluminio con acabado profesional?
          </h2>

          <p className="cta__description">
            En Yare And San Industry desarrollamos proyectos residenciales y
            comerciales con atención al detalle, materiales de calidad y una
            ejecución enfocada en funcionalidad, diseño y presentación final.
          </p>

          <div className="cta__actions">
            <a
              href="https://wa.me/525566176657"
              target="_blank"
              rel="noreferrer"
              className="cta__button cta__button--primary"
            >
              Solicitar cotización
            </a>

            <a
              href="#proyectos"
              className="cta__button cta__button--secondary"
            >
              Ver proyectos
            </a>
          </div>

          <div className="cta__info">
            <div className="cta__info-item">
              <span className="cta__info-label">Atención</span>
              <p className="cta__info-text">CDMX y Área Metropolitana</p>
            </div>

            <div className="cta__info-item">
              <span className="cta__info-label">WhatsApp</span>
              <p className="cta__info-text">55 6617 6657</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;